import type { ReactNode } from "react";
import { AppQueryProvider } from "@/app/QueryProvider";
import { AuthProvider } from "@/features/auth/AuthContext";
import { ConfigProvider } from "@/features/config/ConfigContext";
import { I18nProvider } from "@/i18n/I18nContext";
import { WorkspaceProvider } from "@/features/workspaces/WorkspaceContext";
import { ThemeProvider } from "@/features/theme/ThemeProvider";
import { Toaster } from "@/shared/ui/toaster";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppQueryProvider>
          <ConfigProvider>
            <WorkspaceProvider>
              <I18nProvider>
                {children}
                <Toaster />
              </I18nProvider>
            </WorkspaceProvider>
          </ConfigProvider>
        </AppQueryProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
